import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, reactive, toRefs } from "vue"; // modules

import AuthModule from "@/store/modules/auth";
import ModalModule from "@/store/modules/modal"; // components

import { NavbarAvatar } from "@/components/index"; // interfaces

import { ModalStatus } from "@/constants/modal"; // helpers

import { redirectToLoginPage } from "@/utils/helpers/router.helper"; //services

import DatabaseService from "@/services/database.service";
import dayjs from "dayjs";
import CashFloatModule from "@/store/modules/cash-float";
import { openTopUpForm, confirmLogout, hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import AppModule from "@/store/modules/app";
import DeviceModule from "@/store/modules/device";
import CommonModule from "@/store/modules/common";
import { closeCustomerDisplay, hasCustomerDisplay, openCustomerDisplay } from "@/utils/vue-helpers/customer-display";
export default defineComponent({
  name: "NavbarMainMenu",
  components: {
    NavbarAvatar: NavbarAvatar
  },
  setup: function setup() {
    var state = reactive({
      onLogOut: function () {
        var _onLogOut = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!CashFloatModule.cashFloat) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return confirmLogout();

                case 3:
                  return _context.abrupt("return");

                case 4:
                  AuthModule.UserLogOut(); // remove gId parameter if it is set

                  if (AppModule.gid) {
                    AppModule.removeGID();
                  }

                  redirectToLoginPage();

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onLogOut() {
          return _onLogOut.apply(this, arguments);
        }

        return onLogOut;
      }(),
      toggleModalVisible: function toggleModalVisible(item) {
        ModalModule.setStatus(item);
      },
      dataBackupHandler: function () {
        var _dataBackupHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var db, data, a, file, filename;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return DatabaseService.db;

                case 2:
                  db = _context2.sent;
                  _context2.next = 5;
                  return db === null || db === void 0 ? void 0 : db.exportJSON();

                case 5:
                  data = _context2.sent;
                  //downloading the file
                  a = document.createElement("a");
                  file = new Blob([JSON.stringify(data)], {
                    type: "application/json"
                  });
                  filename = "smeetz-pos-".concat(dayjs().format("DD-MM-YYYY_HH-mm-ss"), ".json");
                  a.href = URL.createObjectURL(file);
                  a.download = filename;
                  a.click();

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function dataBackupHandler() {
          return _dataBackupHandler.apply(this, arguments);
        }

        return dataBackupHandler;
      }(),
      startSales: function () {
        var _startSales = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return openTopUpForm();

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function startSales() {
          return _startSales.apply(this, arguments);
        }

        return startSales;
      }()
    });
    var isCustomerDisplayOpened = computed(function () {
      return CommonModule.isCustomerDisplayOpened;
    });
    var hasLocation = computed(function () {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (DeviceModule.hardwareLocation) {
        return true;
      } else {
        return false;
      }
    });
    return _objectSpread(_objectSpread({
      ModalStatus: ModalStatus
    }, toRefs(state)), {}, {
      hasSalesStarted: hasSalesStarted,
      hasLocation: hasLocation,
      CashFloatModule: CashFloatModule,
      DeviceModule: DeviceModule,
      openCustomerDisplay: openCustomerDisplay,
      hasCustomerDisplay: hasCustomerDisplay,
      closeCustomerDisplay: closeCustomerDisplay,
      isCustomerDisplayOpened: isCustomerDisplayOpened
    });
  }
});